import { app } from '../../app';

app.component('userHeader', {
    templateUrl: require('./header.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/header.component.js